// import { HandThumbDownIcon, HandThumbUpIcon } from '@heroicons/react/24/outline'
// import JSConfetti from 'js-confetti'
import { useLoaderData } from '@remix-run/react'
import clsx from 'clsx'
import { getNewQuoteURL } from '~/helpers'
import type { loader } from '~/routes/report/latest'
import * as gtag from '~/utils/gtag'

export function PromoBar() {
  const { report, promoBarText } = useLoaderData<typeof loader>()
  if (!report.isPublicPromo) return null

  // function thumbsUp() {
  //   const jsConfetti = new JSConfetti()
  //   jsConfetti.addConfetti()
  //   if (window.gtag) {
  //     window.gtag('event', 'reportPromoThumbsUp')
  //   }
  // }

  // function thumbsDown() {
  //   if (window.gtag) {
  //     window.gtag('event', 'reportPromoThumbsDown')
  //   }
  // }
  //
  function clickedPromo() {
    gtag.event({
      action: 'link_click',
      category: 'Report Promo Bar',
      label: promoBarText ?? '',
    })
  }
  return (
    <nav
      className={clsx(
        'p-4 gap-3 flex justify-between items-center sticky top-0 z-50',
        report.brand === 'Point Hacks' ? 'bg-[#c00]' : 'bg-[#283071]',
      )}
    >
      <div className="flex items-center space-x-4 flex-1 justify-center">
        {promoBarText ? (
          <span className="text-white hover:text-zinc-300 text-center">
            <a
              target="_blank"
              onClick={clickedPromo}
              href={getNewQuoteURL(report.brand)}
              className="underline"
              rel="noreferrer"
            >
              {promoBarText}
            </a>
          </span>
        ) : null}
      </div>

      {/* <div className="flex items-center space-x-4">
        <button className="text-white hover:text-zinc-300">
          <HandThumbUpIcon onClick={thumbsUp} className="h-6 w-6" />
        </button>
        <button className="text-white hover:text-zinc-300">
          <HandThumbDownIcon onClick={thumbsDown} className="h-6 w-6" />
        </button>
      </div> */}
    </nav>
  )
}
